import { useEffect } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import ChiSiamo from "@/components/ChiSiamo";
import Valori from "@/components/Valori";
import Metodo from "@/components/Metodo";
import Aree from "@/components/Aree";
import Team from "@/components/Team";
import Contatti from "@/components/Contatti";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";
import { initLenis } from "@/lib/scroll";

function App() {
    useEffect(() => {
        const destroy = initLenis();
        return destroy;
    }, []);

    return (
        <div className="bg-[#FAF7F2] font-sans text-[#1A1A1A] antialiased overflow-x-clip">
            <Header />
            <main>
                <Hero />
                <Marquee />
                <ChiSiamo />
                <Valori />
                <Metodo />
                <Aree />
                <Team />
                <Contatti />
            </main>
            <Footer />
            <Toaster position="bottom-right" />
        </div>
    );
}

export default App;
